<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="reserveOrders"
        @reset="resetHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="80px" @keyup.enter.native="loadData(1)">
            <el-form-item label="预留单号">
              <el-input v-model.trim="filter.reservNo" placeholder="请输入预留单号" clearable/>
            </el-form-item>
            <el-form-item label="预留单类型">
              <el-select v-model="filter.reserveOrderCategory" clearable placeholder="请选择预留单类型">
                <el-option v-for="item in reserveOrderCategoryOptions" :key="item.no" :label="item.name" :value="item.no"/>
              </el-select>
            </el-form-item>
            <el-form-item label="发料状态">
              <el-select v-model="filter.status" clearable placeholder="请选择发料状态">
                <el-option label="未发料" :value="1"/>
                <el-option label="部分发料" :value="2"/>
                <!--                <el-option label="作废" :value="999"/>-->
                <el-option label="已发料" :value="3"/>
              </el-select>
            </el-form-item>
            <el-form-item label="创建人">
              <el-input v-model.trim="filter.creatorName" placeholder="请输入创建人" clearable/>
            </el-form-item>
            <el-form-item label="接收人">
              <el-input v-model.trim="filter.receiver" placeholder="请输入接收人" clearable/>
            </el-form-item>
            <!--            <el-form-item label="交货日期">-->
            <!--              <el-date-picker-->
            <!--                  v-model="deliveryDateRange"-->
            <!--                  type="daterange"-->
            <!--                  range-separator="至"-->
            <!--                  start-placeholder="开始时间"-->
            <!--                  end-placeholder="结束时间"-->
            <!--                  value-format="yyyy-MM-dd"-->
            <!--                  @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="制单日期">-->
            <!--              <el-date-picker-->
            <!--                  v-model="createDateRange"-->
            <!--                  type="daterange"-->
            <!--                  range-separator="至"-->
            <!--                  start-placeholder="开始时间"-->
            <!--                  end-placeholder="结束时间"-->
            <!--                  value-format="yyyy-MM-dd"-->
            <!--                  @change="dateRangeChange('createDateRange', 'orderBeginDate', 'orderEndDate')"/>-->
            <!--            </el-form-item>-->
            <el-form-item label="创建日期">
              <el-date-picker
                  v-model="createDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createDateRange', 'creatorDateStart', 'creatorDateEnd')"/>
            </el-form-item>
            <el-form-item label="需求日期">
              <el-date-picker
                  v-model="requireDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('requireDateRange', 'plnOutDateStart', 'plnOutDateEnd')"/>
            </el-form-item>
            <!--            <el-form-item label="制单人">-->
            <!--              <el-input v-model.trim="filter.creator" placeholder="请输入" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="ERP编号">-->
            <!--              <el-input v-model.trim="filter.billNo" placeholder="请输入ERP订单编号" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="合同号">-->
            <!--              <el-input v-model.trim="filter.customerContractNo" placeholder="请输入合同号" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="项目名称">-->
            <!--              <el-input v-model.trim="filter.projectName" placeholder="请输入项目名称" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="物料编号">-->
            <!--              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="物料名称">-->
            <!--              <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="规格型号">-->
            <!--              <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="备注">-->
            <!--              <el-input v-model.trim="filter.detailNote" placeholder="请输入备注" clearable/>-->
            <!--            </el-form-item>-->
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.confirmAuth" :disabled="scope.row.status === 3" type="primary" @click="$refs.editPage.open(scope.row.id)">
          发料确认
        </el-button>
        <el-button
            v-if="limits.printAuth"
            type="success"
            :loading="scope.row.printLoading"
            @click="handlePrint(scope.row)">
          打印
        </el-button>
        <el-button v-if="limits.postAuth" type="primary" @click="sendToApply(scope.row)">
          领料通知
        </el-button>
        <!--        <el-button v-if="limits.editAuth" type="danger" @click="$refs.editPage.open(scope.row.id)">-->
        <!--          编辑预留单-->
        <!--        </el-button>-->
      </template>
      <template slot="otherBtn">
        <el-button v-if="limits.exportAuth" type="primary" :loading="exportLoading" @click="exportHandle">导出</el-button>
      </template>
    </view-table>
    <reserve-order-edit ref="editPage" @save-success="loadData"/>
  </div>
</template>

<script>

  import loginUtil from "@/util/loginUtil";
  import ViewTable from "@/components/ViewTable";
  import ReserveOrderEdit from "@/views/StoreManagement/ReserveOrder/ReserveOrderEdit";

  export default {
    name: "ReserveOrderList",
    components: { ViewTable,ReserveOrderEdit},
    data() {
      return {
        limits: {
          confirmAuth:this.$auth(517),
          printAuth:this.$auth(518),
          postAuth:this.$auth(519),
          exportAuth:this.$auth(520),
        },
        authIndex: 369,
        importAuth: this.$auth(330),
        filter: {
          salesOrderNO: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          orderBeginDate: "",
          orderEndDate: "",
          submitBeginDate: "",
          submitEndDate: "",
          creatorDateStart: "",
          creatorDateEnd: "",
          plnOutDateStart: "",
          plnOutDateEnd: "",
          customer: "",
          creator: "",
          salesOrderCategory: "",
          reserveOrderCategory: "",
          reservNo: "",
          customerContractNo: "",
          projectName: "",
          billNo: "",
          status: "",
          creatorName: "",
          receiver: "",
          materialNo: "",
          materialName: "",
          specification: "",
          detailNote: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "reservNo",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      // this.$refs.preview.open(params.row, 0, true);
                      this.goto(params.row);
                    },
                  },
                },
                params.row.reservNo,
              );
            },
          },
          {
            tooltip: true,
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            key: "printCount",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            key: "orderMoveTypeDesc",
            width: 260,
            ellipsis: true,
          },
          {
            tooltip: true,
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            tooltip: true,
            key: "creatorName",
            width: 160,
            align: "center",
          },
          {
            tooltip: true,
            key: "plnOutDate",
            width: 160,
            align: "center",
          },
          {
            key: "reservNo",
            width: 180,
            tooltip: true,
          },
          {
            tooltip: true,
            key: "cascadesName",
            width: 350,
          },
          {
            tooltip: true,
            key: "gr_RCPT",
            width: 110,
            align: "center",
          },
          {
            tooltip: true,
            key: "note",
            width: 80,
            align: "center",
          },
          {
            tooltip: true,
            key: "agentName",
            align: "center",
            width: 80,
          },
          {
            key: "action",
            width: 240,
            slot: "action",
            fixed: "right",
          },
        ],
        options: [],
        submitDateRange: [],
        createDateRange: [],
        deliveryDateRange: [],
        requireDateRange: [],
        reserveOrderCategoryOptions: [], // 预留单类型选项
        importCustomerId: "1963",
        YWTimportLoading: false,
        importLoading: false,
        importCustomerLoading: false,
        uploadUrl: window.config.basicServerUrl + "sd/so/importContractFile",
        uploadHeaders: {Authorization: loginUtil.getToken()},
        disabled: false,
        importPdfLoading: false,
        uploadLoading: false,
        selection: [],
        submitLoading: false,
        exportLoading: false, // 添加导出加载状态
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    created() {
      this.getReserveOrderCategory();
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      handlePrint(row) {
        this.$set(row, "printLoading", true);
        this.$http.postForFile("basic", `reserveOrders/print/${row.id}`).then((res) => {
          let blob = new Blob([res.data], {type: "application/pdf"});
          let pdfUrl = window.URL.createObjectURL(blob);
          let newWindow = window.open(pdfUrl, "__blank");
          newWindow.document.close();
          newWindow.print();
          this.getList(-1);
        }).finally(() => {
          this.$set(row, "printLoading", false);
        });
      },

      goto(row) {
        console.log(row);
        this.$router.push({
          path: "/ReserveOrderPreview",
          query: {
            billId: row.id,
            $tabName: row.reservNo,
          },
        });
      },

      sendToApply(row) {
        this.$http.get("basic",`reserveOrders/sendToApply/${row.id}`)
          .then(()=>{
            this.$message.success("通知成功");
            this.getList(1);
          });
      },

      // 获取预留单类型
      getReserveOrderCategory() {
        this.$http.get("basic", "reserveOrders/getReserveOrderCategory")
          .then(res => {
            if (res.success) {
              this.reserveOrderCategoryOptions = res.data;
            }
          })
          .catch(err => {
            console.error("获取预留单类型失败:", err);
            this.$message.error("获取预留单类型失败");
          });
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status !== 3) {
          return  false;
        } else {
          return  true;
        }
      },

      // 导出处理
      exportHandle() {
        this.exportLoading = true;
        let params = Object.assign({}, this.filter);
        this.$http.exportExcel("basic", "reserveOrders/export", params)
          .then((res) => {
            // const blob = new Blob([res.data]);
            // const downloadElement = document.createElement("a");
            // const href = window.URL.createObjectURL(blob);
            // const contentDisposition = res.headers["content-disposition"];
            // let fileName = "导出数据";
            // if (contentDisposition) {
            //   fileName = decodeURI(contentDisposition.split("filename*=utf-8''")[1].split(".")[0]);
            // }
            // downloadElement.style.display = "none";
            // downloadElement.href = href;
            // downloadElement.download = fileName + ".xls"; // 下载后文件名
            // document.body.appendChild(downloadElement);
            // downloadElement.click(); // 点击下载
            // document.body.removeChild(downloadElement); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放掉blob对象
            // 创建Blob对象
            const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            // 创建下载链接
            const link = document.createElement("a");
            const url = window.URL.createObjectURL(blob);

            // 设置下载文件名
            const fileName = `预留单明细数据_${new Date().toLocaleDateString().replace(/\//g, "-")}.xlsx`;
            link.href = url;
            link.download = fileName;

            // 触发下载
            document.body.appendChild(link);
            link.click();

            // 清理
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);

            this.$message.success("导出成功");
          })
          .catch(() => {
            this.exportLoading = false;
            this.$message.error("导出失败");
          })
          .finally(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>






